import { Card, Stack } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { Question_Type } from "@generated/graphql";
import typography from "constants/typography.constants";
import TextEditorControls from "components/form/TextEditorControl";
import { QuestionInputs } from "../../types";
import MultiChoiceBlock from "../MultiChoiceBlock";
import GenerationField from "../GenerationField";

interface ContentTextProps {
  isEditing: boolean;
  skillId: string | undefined;
}

const ContentText = ({ isEditing, skillId }: ContentTextProps) => {
  const form = useFormContext<QuestionInputs>();
  const { watch } = form;
  const questionType = watch("type");
  const isMultiChoiceQuestion = questionType?.id === Question_Type.MultipleChoiceQuestions;

  return (
    <Card>
      <Stack spacing={2}>
        <TextEditorControls
          name='text'
          disabled={!isEditing}
          label='Текст вопроса'
          placeholder={typography.form.placeholder.text}
          rules={{ required: true }}
        />
        <GenerationField
          name='questionComment'
          label='Комментарий к вопросу'
          successText='Текст вопроса сгенерирован'
          generationType='question'
          skillId={skillId}
          isEditing={isEditing}
        />
        {isMultiChoiceQuestion && (
          <MultiChoiceBlock
            form={form}
            isEditing={isEditing}
          />
        )}
      </Stack>
    </Card>
  );
};

export default ContentText;
